$(document).ready(function() {
  //  $('.spb-productdescfont').attr('required').delay(5000);
  setTimeout(function () {
    $("select.spb-productdescfont").prop('required',true);
    // $("select.spb-productdescfont").val($("option:first"))
    $("select.spb-productdescfon option:first").val('');
    $("select.spb-productdescfon option:first").val('selected');
    $("select.spb-productdescfon option:first").val('disabled');
    // console.log("working");
  }, 10000);
 
  $(".sidebar_categories li").on("click", function (e) {
    e.preventDefault();
    var a = $(this).children('ul.subLinks').slideToggle();
    console.log(a);
  }); 


});
